<template>
  <div class="square-progress-ring" :style="{ width: size + 'px', height: size + 'px' }">
    <svg :width="size" :height="size" viewBox="0 0 200 200">
      <!-- 方形背景 -->
      <rect
        x="20"
        y="20"
        width="160"
        height="160"
        fill="none"
        :stroke="backgroundColor"
        :stroke-width="strokeWidthInViewBox"
        :rx="borderRadius"
        :ry="borderRadius"
      />

      <!-- 方形进度条 -->
      <path
        :id="pathId"
        fill="none"
        :stroke="color"
        :stroke-width="strokeWidthInViewBox"
        stroke-linecap="round"
        :d="pathData"
        :style="pathStyle"
      />
    </svg>
  </div>
</template>

<script>
export default {
  name: 'SquareProgress',

  props: {
    // 进度条尺寸（宽高相同）
    size: {
      type: Number,
      default: 28,
    },

    // 进度百分比
    percentage: {
      type: Number,
      default: 0,
    },

    // 进度条颜色
    color: {
      type: String,
      default: '#409eff',
    },

    // 背景颜色
    backgroundColor: {
      type: String,
      default: '#ebeef5',
    },

    // 进度条线条宽度
    strokeWidth: {
      type: Number,
      default: 5,
    },

    // 边框圆角
    borderRadius: {
      type: Number,
      default: 8,
    },

    // 动画持续时间（毫秒）
    duration: {
      type: Number,
      default: 500,
    },
  },

  data() {
    return {
      pathId: `square-progress-${Math.random()
        .toString(36)
        .substr(2, 9)}`,
      pathData: 'M 20,20 L 180,20 L 180,180 L 20,180 Z',
      pathLength: 640, // 160 * 4
    }
  },

  computed: {
    // 将实际线条宽度转换为viewBox内的宽度
    strokeWidthInViewBox() {
      return this.strokeWidth * (200 / this.size)
    },

    // 进度条路径样式
    pathStyle() {
      const offset = this.pathLength - (this.percentage / 100) * this.pathLength
      return {
        strokeDasharray: this.pathLength,
        strokeDashoffset: offset,
        transition: `stroke-dashoffset ${this.duration}ms ease`,
      }
    },
  },

  watch: {
    // 监听尺寸变化
    size() {
      this.$nextTick(() => {
        // 重新计算路径长度（如果需要）
        this.calculatePathLength()
      })
    },
  },

  mounted() {
    this.calculatePathLength()
  },

  methods: {
    calculatePathLength() {
      // 方形路径总长度 = 4条边 * 每条边长度
      this.pathLength = 160 * 4
    },

    // 外部可调用的方法：设置进度
    setProgress(value) {
      if (value >= 0 && value <= 100) {
        this.$emit('update:percentage', value)
      }
    },

    // 外部可调用的方法：设置颜色
    setColor(color) {
      this.$emit('update:color', color)
    },

    // 外部可调用的方法：设置尺寸
    setSize(size) {
      if (size > 0) {
        this.$emit('update:size', size)
      }
    },
  },
}
</script>

<style scoped>

.square-progress-ring {
  position: relative;
  display: inline-block;
}

.progress-content {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
}

.progress-percentage {
  font-size: 24px;
  font-weight: 600;
  color: #303133;
  line-height: 1.2;
}

.progress-status {
  font-size: 14px;
  color: #909399;
  margin-top: 4px;
  line-height: 1.2;
}

</style>
